import { Heading, Image, Paragraph, Text } from '@rover/kibble/core';

import DoodleImage from './images/DoodleTestB.png';

const TestBContent = (): JSX.Element => (
  <>
    <Image height="144px" width="100%" resizeMethod="center" description="sds" src={DoodleImage} />

    <Heading size="300">Leaving them can be tough</Heading>
    <Paragraph size="200">
      {' '}
      Keep up with your pet's every adventure with this offer from our partner Tractive: Get a{' '}
      <Text size="200" fontWeight="semibold">
        free pet GPS & activity tracker{' '}
      </Text>
      with purchase of a subscription. Read success stories and reviews on Tractive's website and
      redeem this limited offer!
    </Paragraph>
  </>
);

export default TestBContent;
